import React, { useEffect, useRef, useState } from "react";
import { BsBellFill } from "react-icons/bs";

import "./CandidateNotificationTopBell.css";
import {
  fetchNotifications,
  fetchUnreadCount,
  markAllNotificationsAsRead,
} from "../../../../services/candidate/api";

const CandidateNotificationTopBell = () => {
  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);
  const [open, setOpen] = useState(false);

  const notificationRef = useRef(null);

  // useEffect(() => {
  //     loadUnreadCount();
  // }, []);

  useEffect(() => {
    // Load immediately
    loadUnreadCount();

    // Poll every 10 seconds
    // const interval = setInterval(() => {
    //   loadUnreadCount();
    // }, 10000);

    // // Cleanup on unmount
    // return () => clearInterval(interval);
  }, []);
  const loadNotifications = async () => {
    try {
      const data = await fetchNotifications();
      setNotifications(data || []);
    } catch (err) {}
  };

  const loadUnreadCount = async () => {
    try {
      const count = await fetchUnreadCount();
      setUnreadCount(count || 0);
    } catch (err) {}
  };

  const handleBellClick = async () => {
    if (!open) {
      await loadNotifications();

      // Uncomment after testing
      try {
        await markAllNotificationsAsRead();
        setUnreadCount(0);
      } catch (err) {}
    }

    setOpen((prev) => !prev);
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        notificationRef.current &&
        !notificationRef.current.contains(e.target)
      ) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // add notification event listener .
  useEffect(() => {
    const handleNewNotification = (event) => {
      const notification = event.detail;
      console.log(notification);
      setNotifications((prev) => [notification, ...prev]);

      setUnreadCount((prev) => prev + 1);
    };

    window.addEventListener("candidate-notification", handleNewNotification);

    return () =>
      window.removeEventListener("candidate-notification", handleNewNotification);
  }, []);

  return (
    <div className="notification-container" ref={notificationRef}>
      <div className="notification-bell" onClick={handleBellClick}>
        <BsBellFill />

        {unreadCount > 0 && (
          <span className="notification-count">{unreadCount}</span>
        )}
      </div>

      {open && (
        <div className="notification-dropdown">
          <div className="notification-header">Notifications</div>

          <div className="notification-list">
            {notifications.length === 0 ? (
              <div className="notification-empty">
                No notifications available
              </div>
            ) : (
              notifications.map((item, index) => (
                <div className="notification-item" key={index}>
                  <p>{item.message}</p>

                  <span>
                    {new Date(
                      item.createdAt || item.notificationTime,
                    ).toLocaleString("en-IN", {
                      day: "2-digit",
                      month: "short",
                      year: "numeric",
                      hour: "2-digit",
                      minute: "2-digit",
                      hour12: true,
                    })}
                  </span>
                </div>
              ))
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default CandidateNotificationTopBell;
